import React from "react";

export default function AccountPanel(props) {
    return (
        <div className="flex h-full w-full flex-col">
            <div className="flex flex-grow flex-row overflow-auto p-4">
                <div className="w-full">
                    <div className="space-y-4">
                        <div>
                            <p className="text-sm text-gray-800">
                                Send data to CEO from outside sources.
                            </p>
                        </div>
                        <div>
                            <strong>
                                Google Docs{" "}
                                <sup style={{ fontSize: "0.5em" }}>TM</sup>
                            </strong>
                            <div className="font-italic pt-4 text-sm text-gray-600">
                                <a
                                    href="https://workspace.google.com/marketplace/app/snworks_send_to_ceo/576253983075?pann=b"
                                    target="_blank"
                                    aria-label="Get it from the Google Workspace Marketplace"
                                    rel="noopener noreferrer"
                                >
                                    <img
                                        alt="Google Workspace Marketplace badge"
                                        alt-text="Get it from the Google Workspace Marketplace"
                                        src="https://workspace.google.com/static/img/marketplace/en/gwmBadge.svg?"
                                        style={{ height: "68px" }}
                                    />
                                </a>
                                <p className="prose-sm mt-4">
                                    Send your docs directly to CEO.
                                </p>
                            </div>
                        </div>
                        <div>
                            <strong>Email</strong>
                            <div className="font-italic text-sm text-gray-600">
                                Coming soon
                            </div>
                        </div>
                        <div>
                            <strong>API</strong>
                            <div className="text-sm text-gray-800">
                                See{" "}
                                <a
                                    href="https://docs.getsnworks.com"
                                    target="_blank"
                                    rel="noreferrer nofollow"
                                    className="text-green-600 underline"
                                >
                                    CEO Documentation
                                </a>
                                .
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
